import createRoute      from '@widesk-ui/tools/createRoute';
import ClientGroupModel from '@models/shop/ClientGroupModel';

export default createRoute.splitView('/client_groups', 'shop', 'ClientGroupSplitView', ClientGroupModel.localize('plural'));
